export const asBase64EncodedJson = value => btoa(JSON.stringify(value));